/**
 * Watermark utility for the BLVX Canvas Editor.
 * Renders the BLVX watermark on export only — NOT visible during editing.
 */
import { FabricText } from 'fabric';

/**
 * Add a BLVX watermark to the canvas for export.
 * Returns the watermark object so it can be removed after export.
 */
export function addExportWatermark(canvas) {
  const watermark = new FabricText('BLVX', {
    fontSize: Math.round(canvas.width * 0.06),
    fontFamily: 'Inter, system-ui, sans-serif',
    fill: 'rgba(255, 255, 255, 0.10)',
    textAlign: 'center',
    originX: 'center',
    originY: 'center',
    left: canvas.width / 2,
    top: canvas.height / 2,
    selectable: false,
    evented: false,
    fontWeight: '700',
    letterSpacing: 400,
  });

  canvas.add(watermark);
  canvas.renderAll();
  return watermark;
}

/**
 * Remove the watermark object after export.
 */
export function removeExportWatermark(canvas, watermark) {
  if (watermark) {
    canvas.remove(watermark);
    canvas.renderAll();
  }
}
